import React, { useState, useRef, useEffect } from 'react';
import './Allcourse.css';
import { NavLink } from 'react-router-dom';

const Allcourse = () => {
    const [toggled, setToggled] = useState(false);
    const [showText] = useState(true);
    const sidebarRef = useRef(null);

    const handleSidebarToggle = () => setToggled(!toggled);

    // Hide sidebar when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setToggled(false);
            }
        };

        if (toggled) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [toggled]);

    const courses = [
        { name: 'B.Tech' }, { name: 'MBA' }, { name: 'M.Tech' }, { name: 'MBBS' },
        { name: 'B.Com' }, { name: 'B.Sc' }, { name: 'B.Sc (Nursing)' }, { name: 'BA' },
        { name: 'BBA' }, { name: 'BCA' }, { name: 'B.Arch' }, { name: 'B.Ed' },
        { name: 'B.Pharma' }, { name: 'B.Sc (Agriculture)' }, { name: 'BAMS' },
        { name: 'LLB' }, { name: 'LLM' }, { name: 'M.Pharma' }, { name: 'M.Sc' },
        { name: 'MCA' }, { name: 'Bachelor of Physiotherapy' }, { name: 'B.Des' },
        { name: 'M.Planning' }, { name: 'B.Planning' }, { name: 'Agriculture' },
        { name: 'Arts' }, { name: 'Commerce' }, { name: 'Computer Applications' },
        { name: 'Design' }, { name: 'Engineering' }, { name: 'Law' },
        { name: 'Management' }, { name: 'Medical' }, { name: 'Paramedical' },
        { name: 'Pharmacy' }, { name: 'Science' }, { name: 'Architecture' },
        { name: 'Aviation' }, { name: 'Dental' }, { name: 'Education' },
        { name: 'Hotel Management' }, { name: 'Mass Communications' },
        { name: 'Veterinary Sciences' }, { name: 'Animation' }, { name: 'Vocational Courses' }
    ];

    return (
        <div>
            {/* Sidebar */}
            {toggled && (
                <div className={`sidebar ${toggled ? 'toggled' : ''}`} ref={sidebarRef}>
                    <div className='p-3'>
                        <div className='d-flex justify-content-between align-items-center nav-item'>
                            <p className='p-2 courseheading'>All Courses</p>
                            <NavLink className="btn-close nav-link text-light" onClick={handleSidebarToggle}></NavLink>
                        </div>
                    </div>

                    {/* Course List */}
                    {showText && (
                        <div className='courselist'>
                            <ul className='list-group list-group-flush'>
                                {courses.map((course, index) => (
                                    <li key={index} className="list-group-item outside_ul">
                                        <a href={`/c_pages/${course.name}`} className="nav-link text-start m-0 p-0" onClick={handleSidebarToggle}>
                                            {course.name} <i className='fa fa-angle-right float-right fw-bold mt-1'></i>
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                </div>
            )}

            {/* Sidebar Toggle Button */}
            <main>
                {!toggled && (
                    <NavLink className="nav-link coursebtn" onClick={handleSidebarToggle}>
                        All Courses <i className="fa fa-angle-down ml-2"></i>
                    </NavLink>
                )}
            </main>
        </div>
    );
};

export default Allcourse;
